/**
 * @fileoverview Agent definition for refine-synthesizer.
 *
 * This agent synthesizes findings, weaknesses, and strengths from a refine session
 * into a coherent editorial brief for the draft-refiner agent.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'refine-synthesizer',
  kind: 'primitive',
  name: 'Refine Synthesizer',
  description: 'Synthesizes findings, weaknesses, and strengths into a coherent editorial brief for refinement.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [],
    usedInComposites: ['run-refine-v2'],
    relatedAgents: [
      'draft-refiner-v2',
      'critique-prose-flow',
      'critique-sensory-atmosphere',
      'critique-voice-emotion',
    ],
  },
};
